var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-card', {
    staticClass: "mx-auto"
  }, [_c('v-card-title', {
    staticClass: "title font-weight-light"
  }, [_c('v-col', {
    staticClass: "text-no-wrap"
  }, [_vm._v(" 收益分析 ")]), _c('v-spacer'), _c('v-tooltip', {
    attrs: {
      "bottom": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref) {
        var on = _ref.on,
          attrs = _ref.attrs;
        return [_c('v-btn', _vm._g(_vm._b({
          staticClass: "mr-2",
          attrs: {
            "icon": "",
            "disabled": !_vm.report || !_vm.report.length
          },
          on: {
            "click": _vm.downloadReport
          }
        }, 'v-btn', attrs, false), on), [_c('v-icon', [_vm._v("download")])], 1)];
      }
    }])
  }, [_c('span', [_vm._v("下载数据")])]), _c('v-tooltip', {
    attrs: {
      "bottom": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref2) {
        var on = _ref2.on,
          attrs = _ref2.attrs;
        return [_c('v-btn', _vm._g(_vm._b({
          attrs: {
            "icon": ""
          },
          on: {
            "click": function click($event) {
              $event.stopPropagation();
              return _vm.filter_item.apply(null, arguments);
            }
          }
        }, 'v-btn', attrs, false), on), [_c('v-icon', [_vm._v("filter_list")])], 1)];
      }
    }])
  }, [_c('span', [_vm._v("过滤数据")])]), _c('v-navigation-drawer', {
    attrs: {
      "app": "",
      "right": ""
    },
    scopedSlots: _vm._u([{
      key: "append",
      fn: function fn() {
        return [_c('v-divider'), _c('v-card-actions', [_c('v-spacer'), _c('v-btn', {
          attrs: {
            "text": ""
          },
          on: {
            "click": _vm.filter_item
          }
        }, [_vm._v("隐藏")]), _c('v-btn', {
          attrs: {
            "color": "secondary",
            "text": ""
          },
          on: {
            "click": _vm.clear_filter
          }
        }, [_vm._v("清空")])], 1)];
      },
      proxy: true
    }]),
    model: {
      value: _vm.incomeDrawer,
      callback: function callback($$v) {
        _vm.incomeDrawer = $$v;
      },
      expression: "incomeDrawer"
    }
  }, [_c('v-list-item', [_c('v-list-item-content', [_c('v-list-item-title', {
    staticClass: "title"
  }, [_vm._v(" 过滤条件：收益 ")])], 1), _c('v-list-item-action', [_c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": _vm.filter_item
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1)], 1), _c('v-divider'), _c('v-card-text', [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.userBusinessType,
      "label": "业务类型",
      "item-text": "name",
      "item-value": "code",
      "outlined": "",
      "dense": "",
      "hide-details": ""
    },
    on: {
      "change": function change($event) {
        return _vm.resetChartData();
      }
    },
    model: {
      value: _vm.query.business_type,
      callback: function callback($$v) {
        _vm.$set(_vm.query, "business_type", $$v);
      },
      expression: "query.business_type"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "items": _vm.accountList,
      "item-text": "personal.name",
      "item-value": "_id",
      "autocomplete": "off",
      "outlined": "",
      "dense": "",
      "clearable": "",
      "label": "内部负责人",
      "small-chips": "",
      "multiple": "",
      "hide-details": ""
    },
    on: {
      "change": function change($event) {
        return _vm.resetChartData();
      }
    },
    model: {
      value: _vm.query.person_in_charge,
      callback: function callback($$v) {
        _vm.$set(_vm.query, "person_in_charge", $$v);
      },
      expression: "query.person_in_charge"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "loading": _vm.agencyLoading,
      "items": _vm.agencyList,
      "search-input": _vm.searchAgency,
      "item-text": "name",
      "item-value": "_id",
      "autocomplete": "off",
      "outlined": "",
      "dense": "",
      "clearable": "",
      "hide-details": "",
      "label": "代理商名称"
    },
    on: {
      "update:searchInput": function updateSearchInput($event) {
        _vm.searchAgency = $event;
      },
      "update:search-input": function updateSearchInput($event) {
        _vm.searchAgency = $event;
      },
      "change": function change($event) {
        return _vm.resetChartData();
      }
    },
    model: {
      value: _vm.query.agency,
      callback: function callback($$v) {
        _vm.$set(_vm.query, "agency", $$v);
      },
      expression: "query.agency"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "loading": _vm.customerLoading,
      "items": _vm.customerList,
      "search-input": _vm.searchCustomer,
      "item-text": "name",
      "item-value": "_id",
      "autocomplete": "off",
      "outlined": "",
      "hide-details": "",
      "clearable": "",
      "dense": "",
      "label": "客户名称"
    },
    on: {
      "update:searchInput": function updateSearchInput($event) {
        _vm.searchCustomer = $event;
      },
      "update:search-input": function updateSearchInput($event) {
        _vm.searchCustomer = $event;
      },
      "change": function change($event) {
        return _vm.resetChartData();
      }
    },
    model: {
      value: _vm.query.customer,
      callback: function callback($$v) {
        _vm.$set(_vm.query, "customer", $$v);
      },
      expression: "query.customer"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.areaList,
      "label": "所属区域",
      "item-text": "name",
      "item-value": "_id",
      "outlined": "",
      "dense": "",
      "clearable": "",
      "hide-details": ""
    },
    on: {
      "change": function change($event) {
        return _vm.resetChartData();
      }
    },
    model: {
      value: _vm.query.area,
      callback: function callback($$v) {
        _vm.$set(_vm.query, "area", $$v);
      },
      expression: "query.area"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-menu', {
    ref: "sign_date",
    attrs: {
      "close-on-content-click": false,
      "transition": "scale-transition",
      "offset-y": "",
      "min-width": "auto"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref3) {
        var on = _ref3.on,
          attrs = _ref3.attrs;
        return [_c('v-text-field', _vm._g(_vm._b({
          attrs: {
            "label": "结算日期开始月份",
            "readonly": "",
            "outlined": "",
            "dense": "",
            "clearable": "",
            "hide-details": ""
          },
          on: {
            "click:clear": function clickClear($event) {
              return _vm.resetQuery('start_date');
            }
          },
          model: {
            value: _vm.query.start_date,
            callback: function callback($$v) {
              _vm.$set(_vm.query, "start_date", $$v);
            },
            expression: "query.start_date"
          }
        }, 'v-text-field', attrs, false), on))];
      }
    }]),
    model: {
      value: _vm.settle_start_menu,
      callback: function callback($$v) {
        _vm.settle_start_menu = $$v;
      },
      expression: "settle_start_menu"
    }
  }, [_c('v-date-picker', {
    attrs: {
      "no-title": "",
      "scrollable": "",
      "type": "month",
      "width": "225"
    },
    on: {
      "input": function input($event) {
        _vm.settle_start_menu = false;
      },
      "change": function change($event) {
        return _vm.resetChartData();
      }
    },
    model: {
      value: _vm.query.start_date,
      callback: function callback($$v) {
        _vm.$set(_vm.query, "start_date", $$v);
      },
      expression: "query.start_date"
    }
  })], 1)], 1), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-menu', {
    ref: "sign_date",
    attrs: {
      "close-on-content-click": false,
      "transition": "scale-transition",
      "offset-y": "",
      "min-width": "auto"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref4) {
        var on = _ref4.on,
          attrs = _ref4.attrs;
        return [_c('v-text-field', _vm._g(_vm._b({
          attrs: {
            "label": "结算日期结束月份",
            "readonly": "",
            "outlined": "",
            "dense": "",
            "clearable": "",
            "hide-details": ""
          },
          on: {
            "click:clear": function clickClear($event) {
              return _vm.resetQuery('end_date');
            }
          },
          model: {
            value: _vm.query.end_date,
            callback: function callback($$v) {
              _vm.$set(_vm.query, "end_date", $$v);
            },
            expression: "query.end_date"
          }
        }, 'v-text-field', attrs, false), on))];
      }
    }]),
    model: {
      value: _vm.settle_end_menu,
      callback: function callback($$v) {
        _vm.settle_end_menu = $$v;
      },
      expression: "settle_end_menu"
    }
  }, [_c('v-date-picker', {
    attrs: {
      "no-title": "",
      "scrollable": "",
      "type": "month",
      "width": "225"
    },
    on: {
      "input": function input($event) {
        _vm.settle_end_menu = false;
      },
      "change": function change($event) {
        return _vm.resetChartData();
      }
    },
    model: {
      value: _vm.query.end_date,
      callback: function callback($$v) {
        _vm.$set(_vm.query, "end_date", $$v);
      },
      expression: "query.end_date"
    }
  })], 1)], 1)], 1)], 1)], 1)], 1), _c('v-divider'), _c('v-card-text', [_c('v-toolbar', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-tabs', {
    on: {
      "change": _vm.resetChartData
    },
    model: {
      value: _vm.incomeType,
      callback: function callback($$v) {
        _vm.incomeType = $$v;
      },
      expression: "incomeType"
    }
  }, [_c('v-tab', [_vm._v("毛利额(元)")]), _c('v-tab', [_vm._v("毛利率(%)")])], 1), _c('v-spacer')], 1), _c('div', {
    style: {
      width: _vm.width,
      height: _vm.height
    },
    attrs: {
      "id": "income_analysis"
    }
  })], 1)], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }